import { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import InnerApp from './InnerApp';
import { subscribeLoading } from './Utilities/loading';

import './App.css';

const App = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const unsubscribe = subscribeLoading(setLoading);
    return unsubscribe;
  }, []);

  return (
    <div
      className="app-root"
      style={{
        pointerEvents: loading ? 'none' : 'auto',
        opacity: loading ? 0.55 : 1,
      }}
    >
      {loading && <div className="spinner"></div>}
      <BrowserRouter>
        <InnerApp />
      </BrowserRouter>
    </div>
  );
};

export default App;
